import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import clsx from "clsx";
import PropTypes from "prop-types";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { useSpring, animated } from "react-spring";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import { HOST_URL, basename } from "../../../config";
import axios from "axios";
import "./scheduleSignUp.css";
import routeConstant from "../../../route/compoent/routeConstant";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "1.5rem",
  },
}));

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element,
  in: PropTypes.bool.isRequired,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
};

function ScheduleForgotPass() {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  // const history = useHistory();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [open, setOpen] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  const handleModalOpen = () => {
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  const letsLogin = () => {
    handleModalClose();
    navigate(routeConstant.SCHEDULE_LOGIN);
  };

  const onSetNewPass = () => {
    const emailAddress = email.trim();
    if (!emailAddress) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill email address!");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        emailAddress
      )
    ) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill correct email address!");
    } else {
      setLoading(true);
      const URL = `${HOST_URL}api/v1/TempAccountData/RecoverPassword`;
      const params = {
        old_password: "",
        new_password: "",
        user_id: email,
      };
      axios
        .post(URL, params)
        .then((res) => {
          setLoading(false);
          if (res.data === "0") {
            setOpenalert(true);
            setSeverity("error");
            setAlertText("Invalid data!");
          } else if (res.data === "1") {
            handleModalOpen();
          } else if (res.data === "2") {
            setOpenalert(true);
            setSeverity("error");
            setAlertText("Email Id is not registered!");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          setOpenalert(true);
          setSeverity("error");
          setAlertText("Something went wrong!");
        });
    }
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <div className="scheduleSignUpComp">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      <Modal
        className={classes.modal + " materialModalContainer"}
        open={open}
        // onClose={handleModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper + " materialModal"}>
            <div className="filterModeComponent singupSuccessModal">
              <div className="modalHeading">
                <h6>Password Sent Successfully!</h6>
              </div>
              <div className="filterModalBody">
                <p>
                  Please check your email!
                  <br />
                  New Password sent successfully <br /> to{" "}
                  <span className="modalEmail">{email}</span>.
                </p>
              </div>
              <div className="modalFooter mt-3">
                <Button variant="contained" onClick={letsLogin}>
                  Go to Login!
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
      <div className="scheduleSignUpCompBody">
        <div className="scheduleSignUpCompBodyInner">
          <img
            src={`/${basename}/Assets/Images/mtslogo.svg`}
            alt="mtsFavIcon"
          />
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <MailOutlineOutlinedIcon /> Enter your registered email
                    address
                  </span>
                }
                value={email}
                type="text"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <div className="loginButton mt-3">
            <Button variant="contained" onClick={() => onSetNewPass()}>
              {loading ? <CircularProgress size="1.5rem" /> : "Submit"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleForgotPass;
